import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { ResponseModel } from "../models/response.model";
import { HttpParams } from "@angular/common/http";
import { BaseService } from "./base.service";
import { PersistenceService } from "angular-persistence";
import { MessageService } from "primeng/components/common/messageservice";
import { IBaseModel } from "../models/abstract/ibaseModel.interface";
import { SortUtil } from "../infrastructure/sort.util";
import { BaseModel } from "../models";

//@Injectable()
export class GeneralService extends BaseService {
  constructor(
    protected messageService: MessageService,
    protected httpClient: HttpClient,
    protected persistenceService: PersistenceService,
    protected urlName: string,
    protected apiName: string
  ) {
    super(messageService, httpClient, persistenceService, urlName, apiName);
  }

  public get(id: any): Observable<ResponseModel> {
    return this.httpClient.get<ResponseModel>(`${this.urlName}/${this.apiName}/get?id=${id}`);
  }

  public async getAsync(id: any): Promise<any> {
    const res = await this.get(id).toPromise();
    if (res.isSuccess) {
      const data = res.data as any;
      return data;
    }
    return null;
  }

  public getAll(arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined): Observable<ResponseModel> {
    let params = new HttpParams();

    if (!pageSize && !pageNumber && arrCols.length === 0) {
      return this.httpClient.get<ResponseModel>(`${this.urlName}/${this.apiName}/getAll`);
    }
    else {
      let cols = null;

      if (arrCols.length > 0) {
        cols = arrCols.join(',');
      }

      if (pageSize)
        params = params.append("pageSize", pageSize.toString());
      if (pageNumber)
        params = params.append("pageNumber", pageNumber.toString());
      if (cols)
        params = params.append("cols", cols);

      return this.httpClient.get<ResponseModel>(`${this.urlName}/${this.apiName}/getAll`, { params: params });
    }
  }

  public getAllNew(arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined): Observable<ResponseModel> {
    let params = new HttpParams();

    if (!pageSize && !pageNumber && arrCols.length === 0) {
      return this.httpClient.get<ResponseModel>(`${this.urlName}/${this.apiName}/getAllNew`);
    }
    else {
      let cols = null;

      if (arrCols.length > 0) {
        cols = arrCols.join(',');
      }

      if (pageSize)
        params = params.append("pageSize", pageSize.toString());
      if (pageNumber)
        params = params.append("pageNumber", pageNumber.toString());
      if (cols)
        params = params.append("cols", cols);

      return this.httpClient.get<ResponseModel>(`${this.urlName}/${this.apiName}/getAll`, { params: params });
    }
  }

  public async getAllNewAsync(arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined): Promise<any> {
    const res = await this.getAllNew(arrCols, pageSize, pageNumber).toPromise();
    if (res.isSuccess) {
      let data = res.data as any;
      data = SortUtil.sortAlphanumerical(data, "name");
      return data;
    }
    return null;
  }

  public async getAllAsync(arrCols: string[] = [], pageSize: number = undefined, pageNumber: number = undefined): Promise<any> {
    const res = await this.getAll(arrCols, pageSize, pageNumber).toPromise();
    if (res.isSuccess) {
      let data = res.data as any;
      data = SortUtil.sortAlphanumerical(data, "name");
      return data;
    }
    return null;
  }

  public create(model: IBaseModel): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(`${this.urlName}/${this.apiName}/create`, model);
  }

  public async createAsync(data: any): Promise<any> {
    const res = await this.create(data).toPromise();
    if (res.isSuccess) {
      const data = res.data as any;
      return data;
    }
    return null;
  }

  public update(model: IBaseModel): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(`${this.urlName}/${this.apiName}/update`, model);
  }

  public async updateAsync(data: any): Promise<any> {
    const res = await this.update(data).toPromise();
    if (res.isSuccess) {
      const data = res.data as any;
      return data;
    }
    return null;
  }

  public delete(model: BaseModel): Observable<ResponseModel> {
    return this.httpClient.post<ResponseModel>(`${this.urlName}/${this.apiName}/delete`, model);
  }

  public async deleteAsync(data: any): Promise<any> {
    const res = await this.delete(data).toPromise();
    if (res.isSuccess) {
      const data = res.data as any;
      return data;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/services/general.service.ts